import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header, Button, Icon } from "semantic-ui-react";

import EditDetailsForm from "../../forms/EditDetailsForm.jsx";
import ImageDetailsView from "./ImageDetailsView.jsx";
import withBasicForm from "/components/forms/withBasicForm.js";
import EditButton from "../../forms/EditButton.jsx";

import { selectCopy } from "/state/reducers/locale/copySelector.js";
import { selectOperationAvailability } from "/state/reducers/operations/operationSelector.js";

import { OPERATIONS } from "/constants/operations.js";
import { VIEW_MODES } from "/constants/modes.js";

const BasicEditDetailsForm = withBasicForm(EditDetailsForm);

class ImageDetailsPanel extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    doEdit: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    copyKey: "image.details_panel"
  };

  constructor(props) {
    super(props);

    this.state = {
      mode: VIEW_MODES.DISPLAY
    };
  }

  // -- EVENT HANDLERS -- //

  onEdit = () => {
    this.setState({ mode: VIEW_MODES.EDIT });
  };

  onCancel = () => {
    this.setState({ mode: VIEW_MODES.DISPLAY });
  };

  onSubmit = values => {
    this.props.doEdit(values);
  };

  // -- RENDER -- //

  renderPanelView() {
    if (this.state.mode === VIEW_MODES.EDIT) {
      return (
        <BasicEditDetailsForm
          {...this.props}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
        />
      );
    } else {
      return <ImageDetailsView {...this.props} className="clear-both" />;
    }
  }

  render() {
    const { mode } = this.state;
    const {
      data,
      disabled,
      copyKey,
      copy,
      updateEntityAvailability: { available }
    } = this.props;

    if (!data) return null;

    return (
      <Segment className="clear-both" disabled={disabled}>
        <Header as="h3" floated="left">
          {copy(`${copyKey}.details`)}
        </Header>
        {available && (
          <EditButton
            mode={mode}
            floated="right"
            disabled={disabled}
            onClick={this.onEdit}
          />
        )}
        <span className="clearfix"></span>
        {this.renderPanelView()}
      </Segment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  updateEntityAvailability: selectOperationAvailability(
    state,
    props,
    OPERATIONS.UPDATE
  ),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ImageDetailsPanel);
